import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(loadSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(listenSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(handleAuthSuccess),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(handleLogout),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(handleSetActiveAccount);

import { push } from 'connected-react-router';
import storage from 'local-storage-fallback';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { resetFullStoryIdentity } from '@signal/utils/fullStory';
import getCookie from '@signal/utils/getCookie';
import { sendCommand as sendServiceWorkerCommand } from '@signal/utils/serviceWorker';
import takeLeading from '@signal/utils/takeLeading';
import { setRecentlyViewedAccount } from '../local/actions';
import { authRequest, authSuccess, authFailure, logout, setActiveAccount } from './actions';
import { LOCAL_STORAGE_TOKEN_KEY, LOCAL_STORAGE_SIGNAL_DATA, CMD_CREATE_SESSION, CMD_DESTROY_SESSION, PC_AUTH_COOKIE, PC_AUTH_COOKIE_QA } from './constants';
import { accountRedirectUrlSelector } from './selectors';
import { getLogoutRedirectUrl, getAuthFailureRedirectUrl } from './utils/redirects';
/**
 * Load saga for the auth loader. "Authenticates" the user by attempting to
 * retrieve his/her access token from local storage. If it doesn't exist, or
 * it has already expired, an attempt is made to request a token from the
 * authentication server. If that request fails, it's assumed that the user is
 * not authenticated and the `authFailure` action is dispatched; otherwise, the
 * `authSuccess` action is dispatched containing the freshly acquired token.
 */

export function loadSaga() {
  var pc_auth;
  return _regeneratorRuntime.wrap(function loadSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(authRequest());

        case 2:
          pc_auth = getCookie(PC_AUTH_COOKIE) || getCookie(PC_AUTH_COOKIE_QA);

          if (pc_auth) {
            _context.next = 7;
            break;
          }

          _context.next = 6;
          return put(authFailure('Unable to authenticate'));

        case 6:
          return _context.abrupt("return");

        case 7:
          _context.next = 9;
          return put(authSuccess());

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * Listener saga for the auth loader.
 */

export function listenSaga() {
  return _regeneratorRuntime.wrap(function listenSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(authSuccess, handleAuthSuccess);

        case 2:
          _context2.next = 4;
          return takeLatest(setActiveAccount, handleSetActiveAccount);

        case 4:
          _context2.next = 6;
          return takeLeading(logout, handleLogout, getLogoutRedirectUrl);

        case 6:
          _context2.next = 8;
          return takeLeading(authFailure, handleLogout, getAuthFailureRedirectUrl);

        case 8:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * ACTION HANDLER SAGAS
 */

/**
 * Messages the service worker to notify of an active auth session.
 */

export function handleAuthSuccess() {
  return _regeneratorRuntime.wrap(function handleAuthSuccess$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return call(sendServiceWorkerCommand, CMD_CREATE_SESSION);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/**
 * Destroys the user's session and redirects to the specified URL.
 * @param {String} getRedirectUrl - returns URL to redirect user to after their
 * session has been destroyed
 */

export function handleLogout(getRedirectUrl) {
  var redirectUrl;
  return _regeneratorRuntime.wrap(function handleLogout$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return call(sendServiceWorkerCommand, CMD_DESTROY_SESSION);

        case 2:
          _context4.next = 4;
          return call([storage, storage.removeItem], LOCAL_STORAGE_TOKEN_KEY);

        case 4:
          _context4.next = 6;
          return call([storage, storage.removeItem], LOCAL_STORAGE_SIGNAL_DATA);

        case 6:
          _context4.next = 8;
          return call(resetFullStoryIdentity);

        case 8:
          _context4.next = 10;
          return call(getRedirectUrl);

        case 10:
          redirectUrl = _context4.sent;
          window.location.assign(redirectUrl);

        case 12:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 * Dispatches setRecentlyViewAccount
 * @param {FluxStandardAction} action
 * @param {Object} action.payload - Active account details
 * @return {Generator}
 */

export function handleSetActiveAccount(_ref) {
  var activeAccount, _ref$meta$options$sho, shouldRedirect, accountRedirectUrl;

  return _regeneratorRuntime.wrap(function handleSetActiveAccount$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          activeAccount = _ref.payload, _ref$meta$options$sho = _ref.meta.options.shouldRedirect, shouldRedirect = _ref$meta$options$sho === void 0 ? true : _ref$meta$options$sho;
          _context5.next = 3;
          return put(setRecentlyViewedAccount(activeAccount));

        case 3:
          _context5.next = 5;
          return select(accountRedirectUrlSelector);

        case 5:
          accountRedirectUrl = _context5.sent;

          if (!shouldRedirect) {
            _context5.next = 9;
            break;
          }

          _context5.next = 9;
          return put(push(accountRedirectUrl));

        case 9:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}